import React from "react";
import "../styles/ReviewManagementSection.css";

const MyReviewCard = ({ orderItem }) => {
    return (
        <div className="mypage-my-review-card">
            {/* 상단 상품 정보 */}
            <div className="mypage-my-review-info">
                <div className="mypage-my-review-image">
                    <img src={orderItem.itemThumbnailPath} alt={orderItem.itemName} />
                </div>
                <div className="mypage-my-review-details">
                    <h4 className="mypage-my-review-title">{orderItem.itemName}</h4>
                    <p className="mypage-my-review-quantity">수량 {orderItem.orderCount}개, {orderItem.subscriptionPeriod}개월 구독</p>
                </div>
            </div>

            {/* 구분선 */}
            <hr className="mypage-my-review-divider" />

            {/* 작성한 리뷰 정보 */}
            <p className="mypage-my-review-date">{orderItem.orderDate}</p>

            <div className="mypage-my-review-content">
                <div className="mypage-my-review-rating">
                    <span className="mypage-my-review-star">⭐ {orderItem.rate}</span>
                    <span className="mypage-my-review-likes">👍 {orderItem.recommendCount}</span>
                </div>
                <p className="mypage-my-review-text">{orderItem.content}</p>
            </div>
            {/* 우측 보상 영역 */}
            <div className="mypage-my-review-actions">
                {orderItem.reward && <button className="mypage-my-review-reward-btn">{orderItem.orderPice * 0.03} 지급완료!</button>}
            </div>
        </div>
    );
};

export default MyReviewCard;
